<div *ngIf="selectedEventTicket$ | async as eventTicket" class="gb-event-ticket-decline-dialog">
  <mat-toolbar role="toolbar" class="gb-dialog-header">
    <h2
      [translate]="'EVENT_TICKET.DECLINE_TICKET.HEADER'"
      [translateParams]="{ action: getActionTranslation(eventTicket) }"
      mat-dialog-title
    ></h2>
    <button mat-icon-button [mat-dialog-close]="!token">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>

  <mat-dialog-content>
    <p
      [innerHtml]="
        'EVENT_TICKET.DECLINE_TICKET.DESCRIPTION'
          | translate
            : {
                action: getActionTranslation(eventTicket),
                ticketPackageName: eventTicket.ticket_package.name
              }
      "
    ></p>
    <p translate="EVENT_TICKET.DECLINE_TICKET.DECLINE_INFO"></p>
  </mat-dialog-content>

  <mat-dialog-actions>
    <div class="flex-col flex-grow px-gap-10">
      <div class="flex-row">
        <button mat-stroked-button [mat-dialog-close]="!token" type="button" translate="CANCEL"></button>
        <button mat-raised-button color="primary" type="button" (click)="onSubmit()">
          <span translate="EVENT_TICKET.DECLINE_TICKET.CONFIRM_BUTTON"></span>
        </button>
      </div>

      <div *ngIf="token" class="flex-row flex-justify-center px-gap-5">
        <span translate="EVENT_TICKET.DECLINE_TICKET.ACCEPT_TEXT"> </span>
        <a
          translate="EVENT_TICKET.DECLINE_TICKET.ACCEPT_LINK"
          (click)="openEventTicketAcceptDialog()"
          [mat-dialog-close]="true"
          class="primary-link"
        >
        </a>
      </div>
    </div>
  </mat-dialog-actions>
</div>
